import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import {
  PiBellDuotone,
  PiHouseDuotone,
  PiTrophyDuotone,
  PiCalendarDuotone,
  PiSoccerBallDuotone,
  PiUserCirclePlusDuotone,
  PiUserDuotone,
  PiSignOutDuotone,
  PiListBulletsDuotone,
} from 'react-icons/pi';
import { useAuth } from '../../app/providers/AuthContext';
import { useNotifications } from '../../app/providers/NotificationContext';
import { publicUserInitial, publicUserName } from '../../shared/utils/userDisplay';
import './Sidebar.css';

const NAV_ITEMS = [
  { to: '/dashboard',     icon: <PiHouseDuotone size={20} />,    label: 'Главная' },
  { to: '/rooms',         icon: <PiTrophyDuotone size={20} />,   label: 'Комнаты' },
  { to: '/events',          icon: <PiCalendarDuotone size={20} />, label: 'События', end: true },
  { to: '/events/external', icon: <PiSoccerBallDuotone size={20} />, label: 'Футбольный API' },
  { to: '/friends',       icon: <PiUserCirclePlusDuotone size={20} />, label: 'Друзья' },
  { to: '/event-types',  icon: <PiListBulletsDuotone size={20} />,  label: 'Типы событий' },
  { to: '/notifications', icon: <PiBellDuotone size={20} />,     label: 'Уведомления', badge: true },
  { to: '/profile',       icon: <PiUserDuotone size={20} />,     label: 'Профиль' },
];

export default function Sidebar() {
  const { user, logout } = useAuth();
  const { unreadCount } = useNotifications();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <aside className="bm-sidebar">
      {/* Логотип */}
      <div className="bm-sidebar__logo">
        <span className="bm-sidebar__logo-icon">⚡</span>
        <span className="bm-sidebar__logo-text">BetMate</span>
      </div>

      {/* Навигация */}
      <nav className="bm-sidebar__nav">
        {NAV_ITEMS.map(({ to, icon, label, badge, end }) => (
          <NavLink
            key={to}
            to={to}
            end={end}
            className={({ isActive }) =>
              `bm-sidebar__item${isActive ? ' bm-sidebar__item--active' : ''}`
            }
          >
            <span className="bm-sidebar__item-icon bm-nav-icon-wrap">
              {icon}
              {badge && unreadCount > 0 && <span className="bm-notification-badge">{formatBadge(unreadCount)}</span>}
            </span>
            <span className="bm-sidebar__item-label">{label}</span>
          </NavLink>
        ))}
      </nav>

      {/* Пользователь + выход */}
      <div className="bm-sidebar__footer">
        {user && (
          <div className="bm-sidebar__user">
            <div className="bm-sidebar__avatar">
              {publicUserInitial(user)}
            </div>
            <span className="bm-sidebar__username bm-truncate">
              {publicUserName(user)}
            </span>
          </div>
        )}
        <button className="bm-sidebar__logout" onClick={handleLogout} title="Выйти">
          <PiSignOutDuotone size={18} />
        </button>
      </div>
    </aside>
  );
}

function formatBadge(count) {
  return count > 99 ? '99+' : count;
}
